export default {
  allContacts: {
    contacts: null,
    contactGroups: null,
  },
};
